import { StageDocumentsInfo } from '../../../models/classes/stage-d/Review-Application.class'
import { P2TextDescription } from 'react-bootstrap-common-script'
import { ClockPendingTaskSvg } from '../../../assets/svg'
import { Helpers } from '../../../utils/helper'
import FileSelectionSegment from '../segments/file-selection-segment'
import { DocumentItem } from '../../../models/polymer/Document.model'
import { Fragment } from 'react'

interface StageDDownloadDocumentsSectionProps {
  documents: StageDocumentsInfo[]
}

function StageDDownloadDocumentsSection({ documents = [], ...props }: StageDDownloadDocumentsSectionProps) {
  return (
    <>
      {
        documents.map((document,_document_index) => {
          const document_key = _document_index;
          return <div className="polymer-stage-d-container__section" style={{ marginBottom: 0 }} key={document_key}>
            <div>
              {documents.map((item, _index) => {
                const key = _index;
                return <div key={key}>
                  <div
                    key={item.uuid}
                    style={{
                      borderBottom: _index !== documents.length - 1 ? "1px dashed #0C8188" : "",
                      paddingTop: _index > 0 ? "16px" : 0,
                    }}>
                    <div className="polymer-stage-d-container__subtitle mb-4">
                      <P2TextDescription color="#000" title="Message" size="1.5rem" />
                      <div className="polymer-stage-d-container__subtitle__date">
                        <ClockPendingTaskSvg />
                        <p>Received on {Helpers.formatDate(item.received_date)}</p>
                      </div>
                    </div>

                    <div className="mb-3">
                      <P2TextDescription color="#000" size="1.3rem" marginBottom="8px" bold={700} title={item.name} />
                    </div>

                    <FileSelectionSegment
                      variant="download-button"
                      comment={item.comments}
                      index={_index}
                      document={new DocumentItem()}
                      files={[]}
                      additionalCheckbox={[]}
                      download_only={true}
                      download_key={item.comments[0].documents[0].key}
                    />
                  </div>
                </div>
              })}
            </div>
          </div>
        })

      }</>

  )
}

export default StageDDownloadDocumentsSection